import { render } from "./ListaLinksPagamentos.vue?vue&type=template&id=381fd868"
import script from "./ListaLinksPagamentos.vue?vue&type=script&lang=js"
export * from "./ListaLinksPagamentos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__